import Loader from 'components/Loader';
import Logger from 'utilities/logger';
const logger = Logger('implicit_callback');
const newrelic = window.newrelic;

const ImplicitCallback = () => {
  newrelic?.addPageAction('userLoggedIn')
  logger.debug('Successfully logged in');
  window.location.replace(window.location.origin);
  return <Loader />;
};

export default ImplicitCallback;
